const resources = {
    signInButton: 'Sign In',
    signInText: ' to see your loves list.',
    yourLoves: 'Your loves will appear here.',
    yourSavedItems: 'From Your Lists'
};

export default function getResource(label) {
    return resources[label];
}
